import z from "zod";
import { apiClient } from "../commonApis/apiClient";
import { ShipmentInventoryAddPayloadSchema } from "../hooks/inventoryHooks";

export interface ShipmentInventory {
  id: string;
  [key: string]: any;
}

export interface LocationVerifyResponse {
  id?: string | null;
  barcodeLabel?: string | null;
  locationType?: string;
  availableQty?: number;
  warehouseId?: string | null;
  multipleWarehouses?: boolean;
  warehouses?: { warehouseId: string; warehouseName: string }[];
}

// API response shape
export interface ShipmentInventoryResponse {
  inventoryMovement: ShipmentInventory[];
  total: number;
  page: number;
  totalPages: number;
}

export interface ShipmentInventoryVerifyPayload {
  locationId?: string;
  awb?: string;
  barcodeId?:string;
  inventoryType?: string;
  warehouseId?: string;
  expiryDate?: string | null;
  allowedLocationType?: string;
}

export type ShipmentInventoryAddPayload = z.infer<typeof ShipmentInventoryAddPayloadSchema>;

export const shipmentInventoryApi = {
  getShipmentInventory: (pageNo: number, limit:number, searchFor: string, warehouseId?: string) =>
    apiClient.get<ShipmentInventoryResponse>(`/api/inventory-movement?page=${pageNo}&limit=${limit}&searchFor=${searchFor}${warehouseId ? `&warehouseId=${warehouseId}` : ""}`),

  shipmentInventoryAdd: (payload: ShipmentInventoryAddPayload | FormData, isFormData: boolean = false) =>
    apiClient.post<ShipmentInventory>("/api/inventory-movement", payload, isFormData),

  getShipmentInventoryByLocationId: (locatoinId: string,pageNo: number, limit:number, searchFor: string) => 
    apiClient.get<ShipmentInventory>(`/api/inventory-movement/by-location/${locatoinId}/?page=${pageNo}&limit=${limit}&searchFor=${searchFor}`),

  verifyShipmentInventory: (payload: ShipmentInventoryVerifyPayload | FormData) =>
      apiClient.post<ShipmentInventory>(`/api/inventory-movement/verify`, payload),

  deleteShipmentInventory: (payload: ShipmentInventoryVerifyPayload | FormData) =>
    apiClient.delete<void>(`/api/inventory-movement`, payload),

  verifyLocationBarcode: (payload: ShipmentInventoryVerifyPayload | FormData) =>
      apiClient.post<LocationVerifyResponse>(`/api/inventory-movement/location-verify`, payload),
};